
<template>
  <div id="detail">
    <Cutscenes v-if="showCutscenes"></Cutscenes>
    <DownloadNav></DownloadNav>
    <template v-if="poData">
      <div class="topic" v-if="poData.tags&&poData.tags.length">
        <router-link :to="{ name: 'topic', params: { tag_id: poData.tags[0].tag_id }}">
          #{{poData.tags[0].tag_name}}
        </router-link>
        <span>话题讨论 {{poData.tags[0].thread_count}}</span>
      </div>
      <div class="po_main">
        <div class="po_top">
          <div class="user_info">
            <div class="avatar" :style="'background-image:url('+poData.face+')'"></div>
            <div class="text">
              <p :class="'user_name sex_'+poData.gender">{{poData.username}}</p>
              <p class="time">{{poData.dateline | timestamp2txt}}</p>
            </div>
          </div>
          <div class="stamp" v-if="poData.tags&&poData.tags.length" :style="'background-image:url('+poData.tags[0].tag_stick+')'"></div>
        </div>

        <div class="po_content">
          <p class="po_txt" v-html="poData.content">

          </p>
          <a :href="poData.extra.url" class="po_tag" v-if="poData.extra.titlte">
            <span class="txt">
              {{poData.extra.titlte}}
            </span>
            <i class="arrow"></i>
          </a>
          <PicBox v-if="poData.images" :images="poData.images" :type="poData.type"></PicBox>
          <div v-if="poData.address" class="location">{{poData.address}}</div>
        </div>
        <div class="po_ctrl">
          <div class="item" @click="openApp">
            <div class="icon comment_btn"></div>
            <div class="txt">评论</div>
          </div>
          <div class="item on" v-if="poData.is_praise" @click="onZan">
            <div class="icon zan_btn"></div>
            <div class="txt">已赞</div>
          </div>
          <div class="item" v-else @click="onZan">
            <div class="icon zan_btn"></div>
            <div class="txt">点赞</div>
          </div>
        </div>
        <div class="zan_wrap" v-if="poData.praise&&poData.praise.length">
          <p class="tit">他们点了赞({{poData.praise.length}})</p>
          <div class="avatar_list">
            <div class="avatar" v-for="(item,index) in poData.praise" v-if="index<7" :key="index" :style="'background-image:url('+item.face+')'"></div>
            <div class="zan_count">{{poData.praise.length}}赞</div>
            <i class="arrow"></i>
          </div>
        </div>
      </div>
      <div class="comments">
        <div class="circle-tit">
          <i class="circle"></i>
          <span class="txt">评论{{poData.comment_count == 0 ? '' : ' ('+poData.comment_count+')'}}</span>
        </div>
        <template v-if="poData.comments">
          <div class="comment-list">
            <div class="comment-item" v-for="(item,index) in poData.comments" :key="index">
              <div class="line"></div>
              <div class="user_info">
                <div class="avatar" :style="'background-image:url('+ item.cuinfo.face +')'"></div>
                <div class="text">
                  <p class="user_name">
                    <span :class="'nick sex_'+item.cuinfo.gender">{{item.cuinfo.username}}</span>
                    <template v-if="item.ruinfo.username">
                      <span class="to">回复</span>
                      <span :class="'nick sex_'+item.ruinfo.gender">{{item.ruinfo.username}}</span>
                    </template>
                  </p>
                  <p class="time">{{item.dateline|timestamp2txt}}</p>
                </div>
              </div>
              <p class="comment-txt" v-html="item.comment"></p>
            </div>
          </div>
          <a class="big-btn" v-if="poData.comment_count - poData.comments.length > 0" @click="loadComment">
            更多精彩评论（{{ poData.comment_count - poData.comments.length }}条）
          </a>
        </template>
        <div class="no_comment" v-if="poData.comment_count == 0">
          <p>暂无评论</p>
          <p>快快抢沙发</p>
        </div>
      </div>
      <div class="others" v-if="poData.recommend">
        <div class="circle-tit">
          <i class="circle"></i>
          <span class="txt">大家都在Po</span>
        </div>
        <img class="pic" :src="poData.recommend.tag_img"></img>
        <p class="tag">#{{poData.recommend.tag_name}}#</p>
        <p class="count">已有{{poData.recommend.thread_count}}份作品</p>
        <a class="big-btn" @click="openAppPoTopic(poData.recommend.tag_id)">我要参与</a>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/mixin.scss";
@import "detail.scss";
</style>

<script>
import DownloadNav from "@/components/download_nav/DownloadNav.vue";
import PicBox from "@/components/pic_box/PicBox.vue";
import Cutscenes from "@/components/cutscenes/Cutscenes.vue";
import { getParam } from "@/untils/until.js";
var qs = require("qs");
export default {
  name: "app",
  data() {
    return {
      showCutscenes: true,
      poData: null,
      page: 0
    };
  },
  components: {
    DownloadNav,
    PicBox,
    Cutscenes
  },
  created() {
    let self = this;
    let obj = {
      params: {
        id: this.$route.params.po_id,
        page: this.page
      }
    };
    if (getParam("from") != null) {
      obj.params.from = getParam("from");
    }
    if (getParam("isappinstalled") != null) {
      obj.params.isappinstalled = getParam("isappinstalled");
    }

    let api = "/index.php?r=web/ajaxpostinfo&v=4.2.0";
    let reqData = {
      data: JSON.stringify(obj)
    };
    self.axios
      .post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(response => {
        let resBody = response.data;
        if (resBody.ret == 0) {
          resBody.data.content = resBody.data.content.replace(/\n/ig,'<br />')
          self.poData = resBody.data;
          self.showCutscenes = false;
          wx.ready(function() {
            wx.onMenuShareTimeline({
              title: resBody.data.content,
              link: resBody.data.share_url,
              imgUrl:
                resBody.data.images && resBody.data.images[0]
                  ? resBody.data.images[0].url
                  : ""
            });
            wx.onMenuShareAppMessage({
              title: resBody.data.content,
              desc: "惠州生活必备-西子湖畔App",
              link: resBody.data.share_url,
              imgUrl:
                resBody.data.images && resBody.data.images[0]
                  ? resBody.data.images[0].url
                  : ""
            });
          });
        }
      });
  },
  methods: {
    loadComment() {
      let self = this;
      let page = self.page + 1;

      let api = "/index.php?r=web/ajaxpostinfo&v=4.2.0";
      let obj = {
        params: {
          id: this.$route.params.po_id,
          page: this.page
        }
      };
      if (getParam("from") != null) {
        obj.params.from = getParam("from");
      }
      if (getParam("isappinstalled") != null) {
        obj.params.isappinstalled = getParam("isappinstalled");
      }
      let reqData = {
        data: JSON.stringify(obj)
      };

      self.axios
        .post(api, qs.stringify(reqData), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(response => {
          let resBody = response.data;
          if (resBody.ret == 0) {
            self.poData.comments = self.poData.comments.concat(
              resBody.data.comments
            );
            self.page = page;
          }
        });
    },

    onZan() {
      let self = this;
      if (!globalData.isLogin) {
        window.location.href =
          "http://my2.xizi.com/user/social-login?type=wx&referrer=" +
          encodeURIComponent(location.href);
        return;
      }
      let api = "/index.php?r=web/ajaxpraise&v=4.2.0";
      let preZanState = self.poData.is_praise;
      let reqData = {
        data: JSON.stringify({
          params: {
            id: self.$route.params.po_id,
            qx: preZanState // 0 点赞 1取消点赞
          }
        })
      };
      self.poData.is_praise = preZanState == 0 ? 1 : 0;
      self.axios
        .post(api, qs.stringify(reqData), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(response => {
          let resBody = response.data;
          console.log(resBody);
          if (resBody.ret !== 0) {
            self.poData.is_praise = preZanState;
          }
        })
        .catch(() => {
          self.poData.is_praise = preZanState;
        });
    },

    openAppPoTopic(tag_id) {
      location.href =
        "https://www.xiziquan.com/quan_to.php?type=po_tag&tag_id=" + tag_id;
    },

    openApp() {
      let self = this;
      location.href =
        "https://www.xiziquan.com/quan_to.php?type=po&pid=" +
        self.$route.params.po_id;
    },
    formatSticker() {
      let potxt = document.querySelectorAll(".po_txt");
      let commentTxt = document.querySelectorAll(".comment-txt");

      if (potxt.length) {
        let txtFontSize = Number.parseInt(
          window.getComputedStyle(potxt[0], null).fontSize.split("px")[0]
        );
        this.forCircle(potxt, txtFontSize);
      }
      if (commentTxt.length) {
        let commentFontSize = Number.parseInt(
          window.getComputedStyle(commentTxt[0], null).fontSize.split("px")[0]
        );
        this.forCircle(commentTxt, commentFontSize);
      }
    },
    forCircle(item, fontSize) {
      for (let i = 0, length = item.length; i < length; i++) {
        let img = item[i].querySelectorAll("img");
        if (img.length) {
          for (let j = 0, length = img.length; j < length; j++) {
            img[j].style.width = fontSize + "px";
            img[j].style.height = fontSize + "px";
          }
        }
      }
    }
  },
  mounted() {
    document.title = "详情";
    // this.wxConfig();
  },
  updated() {
    this.formatSticker();
  }
};
</script>



// WEBPACK FOOTER //
// Detail.vue?5658fe47